import keyMirror from 'keymirror';

// Lite-only history action types. We intentionally don't reuse the legacy
// HistoryActionTypes (PUT_PANELS_IN_HISTORY / UNDO_HISTORY / REDO_HISTORY)
// because the legacy reducer's PUT logic has a long-standing bug — it
// doesn't drop the redo branch on a new edit and doesn't reset `index`
// after pushing a new snapshot — and that legacy reducer is shared with
// the legacy editor's DEBUG-flagged undo path. Building a separate slice
// + actions keeps Lite's corrected reducer entirely isolated.
export const LiteHistoryActionTypes = keyMirror({
  PUT_LITE_PANELS_IN_HISTORY: undefined,
  LITE_UNDO_HISTORY: undefined,
  LITE_REDO_HISTORY: undefined,
  // Seed the slice with the currently-loaded panels as the "anchor".
  // Dispatched by UBuilderLiteContainer once panels finish loading.
  // Without this, the reducer's initial [[]] sits at the bottom of the
  // stack and a refreshed project lets the user undo back to "empty"
  // even though they didn't add the original panels in this session.
  LITE_SEED_HISTORY: undefined,
  // Restore a previously-saved full history state (snapshots + index +
  // flags). Used when switching between roof areas so each roof keeps
  // its own undo stack across visits.
  LITE_RESTORE_HISTORY: undefined,
});
